// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + chunkId + "-" + "c4b3615a70685da5fbe8" + ".css";
};